import { useRef } from "react";

/**
 * A "live" ref is a container for a value that might or might not change each render
 * but will always be up-to-date with the latest value.
 *
 * This is useful when a value should be a part of an effect, memoization, or callback but
 * should NOT cause the effect, memoization, or callback to reevaluate.
 *
 * One reason you might do this is in context value memoization where you want to more tightly
 * control when a React context's value is re-memoized based on props passed to that value's
 * creator.
 */
export function useLiveRef(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
//# sourceMappingURL=useLiveRef.js.map